import { usePermissions } from "components/context/permissionsContext";

export const useDispatchBoardPermission = () => {
  const { userPermissions } = usePermissions();

  const hasDbGetPermission = userPermissions.some(
    (item) =>
      item.module === "DispatchBoard" &&
      item.controller === "DispatchBoard" &&
      item.identifier === "dispatchboard-get" &&
      item.hasPermission
  );
  const hasDbSavePermission = userPermissions.some(
    (item) =>
      item.module === "DispatchBoard" &&
      item.controller === "DispatchBoard" &&
      item.identifier === "dispatchboard-save" &&
      item.hasPermission
  );
  const hasDbDeletePermission = userPermissions.some(
    (item) =>
      item.module === "DispatchBoard" &&
      item.controller === "DispatchBoard" &&
      item.identifier === "dispatchboard-delete" &&
      item.hasPermission
  );
  
  const DispatchBoardPermissionProps = {
    hasDbGetPermission,
    hasDbSavePermission,
    hasDbDeletePermission
  };

  return {
    DispatchBoardPermissionProps
  };
};
